import { render } from "./ChatGPTBotSettings.vue?vue&type=template&id=d8abfc16"
import script from "./ChatGPTBotSettings.vue?vue&type=script&lang=js"
export * from "./ChatGPTBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__